import appReservation from "../../views/appCustomers/reservation.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("reservation", {
    url: "reservation/:id",
    parent: "app",
    views: {
      view: {
        template: appReservation,
      },
    },
    reloadOnSearch: false,
    data: { title: "Reservation" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation.urls.js